import { Localized, useLocalization } from '@fluent/react';

import { InputFormik } from '#/components/controls/Input';
import { VehicleListboxFormik } from '#/components/controls/VehicleListbox';
import { VehicleDetailsFragment } from '#/__generated__/graphql/graphql';

const TransporterInfoForm: React.FC<TransporterInfoFormProps> = ({ preferredVehicleBodyType }) => {
  const { l10n } = useLocalization();

  return (
    <div className="space-y-2">
      <div className="grid gap-2 md:grid-cols-2 md:gap-4">
        <Localized id="driver" attrs={{ placeholder: true }}>
          <InputFormik label={l10n.getString('driver')} name="driver" />
        </Localized>
        <Localized id="telephone" attrs={{ placeholder: true }}>
          <InputFormik label={l10n.getString('telephone')} name="driverTelephone" />
        </Localized>
        <Localized id="vehicle-number" attrs={{ placeholder: true }}>
          <InputFormik label={l10n.getString('vehicle-number')} name="vehicleRegistrationPlate" />
        </Localized>
        <Localized id="vehicle-type" attrs={{ placeholder: true }}>
          <VehicleListboxFormik
            filterItem={(item) => item.bodyType === preferredVehicleBodyType}
            getKey={(item: Omit<VehicleDetailsFragment, 'id'>) => item.name}
            // TODO: simplify ideally -> item => item, use sanitizer?
            getValue={({ id, ...item }) => ({
              ...item,
              cargoVolume: {
                unitCode: item.cargoVolume?.unitCode,
                value: item.cargoVolume?.value,
              },
            })}
            label={l10n.getString('vehicle-type')}
            name="vehicle"
          />
        </Localized>
        {/*
        <Localized id="expectedArrivalDate" attrs={{ placeholder: false }}>
          <DatePickerFormik
            className="w-full border rounded-base border-neutral-300 hover:bg-neutral-100"
            dateFormat="MMM dd, yyyy h:mm aa"
            label={l10n.getString('delivery-date')}
            minDate={new Date()} // Set to able to select today onwards
            name="expectedArrivalDate"
            showTimeSelect
          />
        </Localized>
        */}
      </div>
    </div>
  );
};
export type TransporterInfoFormProps = {
  preferredVehicleBodyType?: string | null;
};

export default TransporterInfoForm;
